import { useCallback, useState } from "react";

// Owns open/close state for the schedule modal plus optional pre-fill payload
// (used by the profile Edit flow). The "create" call site can simply call
// open() with no args; the "edit" call site passes the existing subscription.
export const useScheduleReportModal = () => {
	const [open, setOpen] = useState(false);
	const [initialValues, setInitialValues] = useState(null);

	const openModal = useCallback((prefill = null) => {
		setInitialValues(prefill);
		setOpen(true);
	}, []);

	const closeModal = useCallback(() => {
		setOpen(false);
		setInitialValues(null);
	}, []);

	return { open, initialValues, openModal, closeModal };
};
